// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__YRnOd","tooltipWpapper":"Tooltip_tooltipWpapper__BxiTq"};